<script>
export default {
  name: 'Rule',
  functional: true,

  props: {
    size: {
      type: [Number, String],
      default: 1
    }
  },

  render: function (createElement, context) {
    return createElement('div', {
      'class': [
        'Rule'
      ]
    })
  }
}
</script>

<style>
@import 'properties';

.Rule {
  height: 1px;
  background-color: var(--c-grey-xxlt);
  border: none;
}

.theme-dk .Rule {
  background-color: var(--c-black);
}
</style>



// WEBPACK FOOTER //
// Rule.vue?47114b62